import { Helmet } from "react-helmet-async";

const SITE_NAME = "Videoileo";
const DEFAULT_IMAGE = "/og-image.png";
const CANONICAL_ORIGIN = "https://www.videoileo.com";

export default function Seo({ title, description, path = "", noindex = false, image }) {
  const url = `${CANONICAL_ORIGIN}${path}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — AI Faceless Video Studio`;
  const img = `${CANONICAL_ORIGIN}${image || DEFAULT_IMAGE}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
